import { IconGrid } from "../../atoms/";
import HomeCarousel from "../../carousel";
import { data } from "../../carousel/dat";

function Home() {
  let version = process.env.REACT_APP_VERSION;
  console.log("christee version: ", version);

  return (
    <div>
      <main id="maincontent" className="interior">
        <div className="container content pt-5">
          <div className="row">
            <div className="col-md-12">
              <div className="contentpadding">
                <h2>
                  AskChristee is a simple to use real estate finance platform.
                </h2>
                <p>
                  Our mission is to provide in-depth information that will
                  allow for making smarter decisions when purchasing real
                  estate.
                </p>
                <IconGrid />
                <br />
                <HomeCarousel data={data} />
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}

export default Home;
